import { NotifyHelper } from "../../../helpers/toast";
import { objDoiTuongTuyenSinhDefine } from "../../action-types/crm-category/IDmDoiTuongTuyenSinhActionTypes";
import { generateActionForKey, generateActions } from "../generateActions";

export const doiTuongTuyenSinhActions = {
    ...generateActions(objDoiTuongTuyenSinhDefine, "DOI_TUONG_TUYEN_SINH"),
    ...generateActionForKey(objDoiTuongTuyenSinhDefine, "DOI_TUONG_TUYEN_SINH",
        "LOAD_ERROR", (m: any) => NotifyHelper.Error(m)),
    ...generateActionForKey(objDoiTuongTuyenSinhDefine, "DOI_TUONG_TUYEN_SINH",
        "SAVE_SUCESS", (m: any) => NotifyHelper.Success("Lưu thành công")),
    ...generateActionForKey(objDoiTuongTuyenSinhDefine, "DOI_TUONG_TUYEN_SINH",
        "SAVE_ERROR", (m: any) => NotifyHelper.Error(m)),
    ...generateActionForKey(objDoiTuongTuyenSinhDefine, "DOI_TUONG_TUYEN_SINH",
        "DELETE_SUCESS", (m: any) => NotifyHelper.Success("Xóa thành công")),
    ...generateActionForKey(objDoiTuongTuyenSinhDefine, "DOI_TUONG_TUYEN_SINH",
        "DELETE_ERROR", (m: any) => NotifyHelper.Error(m))
}
